






























































































import { CodeRuleServiceProxy } from "@/service-proxies/app-v2/code.service-proxies";
import { ScrappedReasonServiceProxy } from "@/service-proxies/app-v2/qc.service-proxies";
import Vue from "vue";
const csp = new CodeRuleServiceProxy();
const scrappedReasonServiceProxy = new ScrappedReasonServiceProxy();
export default Vue.extend({
  name: "AddorEditScrapType",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    addType: {
      type: Boolean,
      default: false,
    },
    editForm: {
      type: Object,
    },
    currentType: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      scrappedCodeIdList: [],
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
      form: {
        typeId: "",
        code: "",
        reason: "",
        remark: "",
      },
      rules: {
        code: [
          { required: true, message: this.$t('page_please_write_scrapreason_code'), trigger: 'change' },
          { max: 128, message: this.$t('page_max_128_code'), trigger: 'change' },
        ],
        reason: [
          { required: true, message: this.$t('page_please_write_scrapreason'), trigger: 'change' },
          { max: 255, message: this.$t('page_max_128_code'), trigger: 'change' },
        ],
        remark: [{max: 128, message: this.$t('page_max_256_code'), trigger: 'blur' }],
      },
      saveLoading: false
    };
  },
  created() {
    csp.list("ScrappedTypeObject").then((res) => {
      this.scrappedCodeIdList = res;
    });
  },
  computed: {
    title () {
      return  this.addType ? this.$t('create'): this.$t("edit")
    }
  },
  watch: {
    editForm (val) {
      console.log('22', val)
      if (val) {
        this.form = val
      }
    }
  },
  methods: {
    handleOk() {
      this.saveLoading = true
      console.log('111', this.$refs.ruleForm)
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.form.typeId = this.currentType.id
          if (this.addType) {
            scrappedReasonServiceProxy.qcSaveScrappedReason(this.form).then(res => {
              this.$emit('cancel', true)
              this.saveLoading = false
            }).catch(() => {
              this.saveLoading = false
            })
          } else {
            scrappedReasonServiceProxy.qcUpdateScrappedReason(this.form).then(res => {
              this.saveLoading = false
              this.$emit('cancel', true)
            }).catch(() => {
              this.saveLoading = false
            })
          }
        } else {
          this.saveLoading = false
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleCancel() {
      this.reset()
      this.$emit('cancel', false)
    },
    reset () {
      this.form = {
        typeId: "",
        code: "",
        reason: "",
        remark: "",
      }
    }
  }, 
});
